<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">{{ title }}</span>
    </p>
    <div style="position: relative;">
      <Spin v-if="loadingStatus" fix />
      <Form ref="form" :label-width="90" :model="formFields" :rules="ruleValidate">
        <FormItem label="角色名称:" prop="name">
          <Input v-model="formFields.name" placeholder="请输入角色名称..." size="small" />
        </FormItem>
        <FormItem label="角色代号:" prop="code">
          <Input v-model="formFields.code" placeholder="请输入'ROLE_'开头的角色代号..." size="small" />
        </FormItem>
        <FormItem label="是否可见:" prop="visible">
          <RadioGroup v-model="formFields.visible">
            <Radio :label="1" :true-value="1">
              可见
            </Radio>
            <Radio :label="0" :true-value="0">
              隐藏
            </Radio>
          </RadioGroup>
        </FormItem>
        <input v-model="formFields.id" type="hidden" name="id"></input>
      </Form>
    </div>
    <div slot="footer">
      <Button
        type="primary"
        :disabled="loadingStatus"
        size="small"
        icon="ios-checkmark-circle-outline"
        :loading="submit"
        @click="saveOrUpdate"
      >
        保存
      </Button>
    </div>
  </Modal>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'RoleDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    },
    action: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    const validateRoleCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('角色代号不能为空!'))
      }
      if (!value.trim().startsWith('ROLE_')) {
        callback(new Error('角色代码必须以‘ROLE_’开头..'))
      }
      if (value.trim() === 'ROLE_') {
        callback(new Error('非法角色代码..'))
      }
      callback()
    }
    return {
      loadingStatus: false,
      modal: true,
      submit: false,
      formFields: {
        name: '',
        code: '',
        visible: 1,
        id: this.id
      },
      ruleValidate: {
        name: [
          { required: true, message: '角色名称不能为空!', trigger: 'blur' }
        ],
        code: [
          { validator: validateRoleCode, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    title() {
      if (this.caption) {
        return this.caption
      } else {
        return this.id ? '编辑角色' : '添加新角色'
      }
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    }
  },
  watch: {
    showModal(val) {
      this.resetForm()
      this.loadingStatus = false
      if (this.action && this.id) {
        this.loadingStatus = true
        request({
          url: this.action + '/' + this.id,
          method: 'get'
        }).then(res => {
          this.loadingStatus = false
          this.formFields = res.data
        }).catch(() => {
          // this.$Notice.error({
          //   title: '服务器数据请求失败',
          //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
          // })
          this.loadingStatus = false
        })
      }
    }
  },
  methods: {
    resetForm: function() {
      this.$refs.form.resetFields()
      this.formFields.id = 0
    },
    saveOrUpdate: function() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.action) {
            this.$refs.form.validate((valid) => {
              if (valid) {
                this.submit = true
                const isNew = this.formFields.id === 0
                request({
                  url: this.action + (isNew ? '' : ('/' + this.id)),
                  method: isNew ? 'POST' : 'PUT',
                  data: this.formFields
                }).then(res => {
                  this.loadingStatus = false
                  this.formFields = res.data
                  this.$Notice.success({
                    title: '角色 `' + this.formFields.name + '` 保存成功!'
                  })
                  this.submit = false
                  this.closeModal(true)
                }).catch(() => {
                  // this.$Notice.error({
                  //   title: '服务器数据请求失败',
                  //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
                  // })
                  this.loadingStatus = false
                  this.submit = false
                })
              }
            })
          }
        }
      })
    },
    closeModal: function(changed = false) {
      this.$emit('on-close', changed)
    }
  }
}
</script>

